import * as qs from 'querystring';
import { Location } from 'history';

const searchToQuery = (location: Location) => {
  const querystring = location.search ? location.search.slice(1) : '';
  return qs.parse(querystring);
};

export {
  searchToQuery,
};
